import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const SubmitButton = styled.div((props) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '1rem'
}))

export const SCCont = styled.div((props) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}))

export const SCContDetail = styled.div((props) => ({
  display: 'flex',
  marginTop: `${props.sub ? '0' : '1rem'}`,
  flexDirection: 'column',

  '&>div:first-child': {
    marginLeft: '0px',
    flex: 1
  },

  '&>div': {
    marginLeft: '0px',
    flex: 1
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',

    '&>div:first-child': {
      marginLeft: '0px',
      flex: 1
    },
  
    '&>div': {
      marginLeft: '1rem',
      flex: 1
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',

    '&>div:first-child': {
      marginLeft: 0,
      flex: 1
    },
  
    '&>div': {
      marginLeft: '1rem',
      flex: 1
    },
  },

}))